export default [{
  "id": 0,
  "name": "BoredApeYachtClub",
  "collectionItem_url": "https://lh3.googleusercontent.com/3rllkFLC_4ZIjcKi9tKHfVMvhcaSw9SLaJ8GbOGg5Joouct5bpdeBNJLz3t9Tt1Q1YiDGsfA_mO8nlBlLsZxJ53ZG4yR_MpDU327Ji0=w206",
  "avatar": "https://lh3.googleusercontent.com/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB=s64",
  "isVerified": true,
  "price": {
    "floor": 29.07
  },
  "change": {
    "day": {
      "percentage": 1.01,
      "amount": 7955.24
    },
    "week": {
      "percentage": -20.37,
      "amount": 12755.29
    },
    "month": {
      "percentage": 61.0,
      "amount": 88439.07
    }
  }
}, {
  "id": 1,
  "name": "CryptoPunks",
  "collectionItem_url": "https://lh3.googleusercontent.com/V7yIEHLmpvZUpKdzsdUkzWtRXOY67NcCiKEOekD5qtBtHRxUaSOpjnH0k23byzUW7OBhVvuYyrTV07wpFO6j70XRerHFJRI6WPa-=w206",
  "avatar": "https://lh3.googleusercontent.com/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE=s64",
  "isVerified": true,
  "price": {
    "floor": 11.36
  },
  "change": {
    "day": {
      "percentage": -95.33,
      "amount": 6255.55
    },
    "week": {
      "percentage": -75.69,
      "amount": 15822.62
    },
    "month": {
      "percentage": -26.2,
      "amount": 89723.41
    }
  }
}, {
  "id": 2,
  "name": "Moonbirds",
  "collectionItem_url": "https://lh3.googleusercontent.com/5-Nx0qj4MYyHG2-l9p_4U27ly5qddKsaV69Qs295VsXUvgKj0FYmtKq_TFv-ASFa-R9K-q8YnIs6ZSNE04EQvyDe5oIPwz8OUEDzhQ=w206",
  "avatar": "https://lh3.googleusercontent.com/sn5iLHUcNuUO98w_9Z7cat32hiqvVkPYr6tzHUacESg4PePh9M3jySvpttyWWXHD2e8M4PNQqgorU9sUvpX-FHQHXFBiCpKjloC2nA=s64",
  "isVerified": false,
  "price": {
    "floor": 90.24
  },
  "change": {
    "day": {
      "percentage": 99.49,
      "amount": 2846.99
    },
    "week": {
      "percentage": 65.24,
      "amount": 19628.67
    },
    "month": {
      "percentage": -59.47,
      "amount": 89199.8
    }
  }
}, {
  "id": 3,
  "name": "Azuki",
  "collectionItem_url": "https://lh3.googleusercontent.com/tlMxSh5Rf5FJW_mTTyw8jS_OwdD3BKf2F71Tk3noa1NSJlPTht8dBcm-RjoBiFEFQAkpbpcgXpbkHhdqOArOhxG_4t_mUiNG498WGw=w206",
  "avatar": "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s64",
  "isVerified": true,
  "price": {
    "floor": 22.59
  },
  "change": {
    "day": {
      "percentage": -1.91,
      "amount": 4319.04
    },
    "week": {
      "percentage": -73.65,
      "amount": 14098.07
    },
    "month": {
      "percentage": -75.94,
      "amount": 59773.96
    }
  }
}, {
  "id": 4,
  "name": "HAKI NFT",
  "collectionItem_url": "https://lh3.googleusercontent.com/tmDxtrM7y8dGsdMAZ-B598Y-GXkA_Eh0zOPhUMSKsKV71easUhB9_jlCUMMcgBgN0NlCNX6GqJR1HSnRW1_Qe3qrVgBmuMSQbsLUNw=w206",
  "avatar": "https://lh3.googleusercontent.com/Cq1G1NVYtecZKoHdzDt9xkYliJPpkoDniUAEIodD_WFfhaykPpyxrMxggWcIdfqrSx8xajwxT5UYehZNwNPI5l8s5xeLC88xmhi8oQ=s64",
  "isVerified": false,
  "price": {
    "floor": 20.14
  },
  "change": {
    "day": {
      "percentage": 38.74,
      "amount": 3918.2
    },
    "week": {
      "percentage": -91.43,
      "amount": 18483.44
    },
    "month": {
      "percentage": -70.59,
      "amount": 22711.11
    }
  }
}, {
  "id": 5,
  "name": "Doodles",
  "collectionItem_url": "https://lh3.googleusercontent.com/nYH0MhgV94bzuhPsC4S0ZO83DtA1551pnvD3ezWOpLExxz7Je7BbVP2k9hXYvC1ypMBkQbdMMUgQ-RbeEXayybeuqv7-MPyHY4La1RU=w206",
  "avatar": "https://lh3.googleusercontent.com/7B0qai02OdHA8P_EOVK672qUliyjQdQDGNrACxs7WnTgZAkJa_wWURnIFKeOh5VTf8cfTqW3wQpozGedaC9mteKphEOtztls02RlWQ=s64",
  "isVerified": true,
  "price": {
    "floor": 82.4
  },
  "change": {
    "day": {
      "percentage": -80.62,
      "amount": 6987.53
    },
    "week": {
      "percentage": 92.54,
      "amount": 15506.17
    },
    "month": {
      "percentage": -43.35,
      "amount": 55299.05
    }
  }
}, {
  "id": 6,
  "name": "The Sandbox",
  "collectionItem_url": "https://lh3.googleusercontent.com/vxPRqRqF5XXXiKcY2WmySxPph8n8DIT4-9lUcGPOOf5FDxzODslqcSy5kr5gt8gEI6c20fDmWTMi9CH86GlPo5wuTMbiuFmCPV2q=w206",
  "avatar": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s64",
  "isVerified": false,
  "price": {
    "floor": 99.67
  },
  "change": {
    "day": {
      "percentage": 20.36,
      "amount": 6108.71
    },
    "week": {
      "percentage": -0.07,
      "amount": 13159.54
    },
    "month": {
      "percentage": -27.28,
      "amount": 21894.42
    }
  }
}, {
  "id": 7,
  "name": "Milady Maker",
  "collectionItem_url": "https://lh3.googleusercontent.com/esQDThqSsPd2PjTYZ7dkBdjzfuE3QgZAfh-IHq5bTHLYh2H4nbqTXBGQZPLC90B9EsolTgQNXrW81qvsn6jEhBxnI-wChE2tI69PCQ=w206",
  "avatar": "https://lh3.googleusercontent.com/a_frplnavZA9g4vN3SexO5rrtaBX_cBTaJYcgrPtwQIqPhzgzUendQxiwUdr51CGPE2QyPEa1DHnkW1wLrHAv5DgfC3BP-CWpFq6BA=s64",
  "isVerified": true,
  "price": {
    "floor": 37.89
  },
  "change": {
    "day": {
      "percentage": -96.93,
      "amount": 6589.97
    },
    "week": {
      "percentage": -84.88,
      "amount": 13880.65
    },
    "month": {
      "percentage": -47.02,
      "amount": 39363.05
    }
  }
}, {
  "id": 8,
  "name": "PROOF Collective",
  "collectionItem_url": "https://lh3.googleusercontent.com/kR7YztId1NIN9dmJO41Bb0ZlwvwBsBfl9-JhptqriL1laOqaZ6b_lCOi2WukIqxE0f7DMJ_sSvhYkaElNGvY2tA=w206",
  "avatar": "https://lh3.googleusercontent.com/ipAyQg6Xlgvwxma0Qp0a1gqdsZepRvHR4ZLsPN3mOFvIR1aznNiWFEgba2gcVqQwJS5BoJilLPrA2DRq2DVOnwKc3tDovmEdjR4qb-0=s64",
  "isVerified": true,
  "price": {
    "floor": 48.9
  },
  "change": {
    "day": {
      "percentage": 58.05,
      "amount": 2440.64
    },
    "week": {
      "percentage": -59.94,
      "amount": 18228.55
    },
    "month": {
      "percentage": 13.77,
      "amount": 84333.63
    }
  }
}, {
  "id": 9,
  "name": "VeeFriends",
  "collectionItem_url": "https://lh3.googleusercontent.com/28jYQ9Toyfs8QPOUd_k86RhLSiventoMuhQjmqiE-TXVFlpoX_g_ncau0kO8GZb3-arCo712XcgsPZYyzYPop-V5=w206",
  "avatar": "https://lh3.googleusercontent.com/5y-UCAXiNOFXH551w5bWdZEYOCdHPwbqmcKb-xa3uVQEjQgxvih3HtZWSmzqDqd0uk7kIqFrZhw32Gt6xPBFg4t_n9BKhpou-dwnOg=s64",
  "isVerified": true,
  "price": {
    "floor": 86.16
  },
  "change": {
    "day": {
      "percentage": 86.75,
      "amount": 9458.44
    },
    "week": {
      "percentage": -83.03,
      "amount": 16308.03
    },
    "month": {
      "percentage": 23.83,
      "amount": 72135.36
    }
  }
}, {
  "id": 10,
  "name": "CyberBrokers",
  "collectionItem_url": "https://lh3.googleusercontent.com/Uagikn-Lhn2W44V54_5UcsnMqrBESw6TkHV3PF_HiDXZZdryannrULVLEsrSeqLZxlSJZ3aA2E7hq3O62Ta4237jEQ=w206",
  "avatar": "https://lh3.googleusercontent.com/Qd1IEPYz_0YlMaclPwb6_9PyP7afZIzH15IdIU2X6t1Wvg81DwpAaWOY0cNmxy173C4yMA7sM3xF9-HJsCSKJdx6KvDR3old3IKuTIc=s64",
  "isVerified": true,
  "price": {
    "floor": 94.1
  },
  "change": {
    "day": {
      "percentage": 73.85,
      "amount": 2376.28
    },
    "week": {
      "percentage": 48.7,
      "amount": 10444.27
    },
    "month": {
      "percentage": 75.42,
      "amount": 95380.62
    }
  }
}, {
  "id": 11,
  "name": "Bored Ape Kennel Club",
  "collectionItem_url": "https://lh3.googleusercontent.com/M9Tyqa3vOo5ApTCmIq0ot64XcjPb1NlImqhJnQmAmhWghbhF-oJrG-HVM7p4J9lQaHkIA_CAximNRn3H81dOP43S=w206",
  "avatar": "https://lh3.googleusercontent.com/l1wZXP2hHFUQ3turU5VQ9PpgVVasyQ79-ChvCgjoU5xKkBA50OGoJqKZeMOR-qLrzqwIfd1HpYmiv23JWm0EZ14owiPYaufqzmj1=s64",
  "isVerified": false,
  "price": {
    "floor": 54.25
  },
  "change": {
    "day": {
      "percentage": -68.24,
      "amount": 6365.47
    },
    "week": {
      "percentage": 53.31,
      "amount": 17713.66
    },
    "month": {
      "percentage": -88.76,
      "amount": 64646.23
    }
  }
}, {
  "id": 12,
  "name": "Toxic Skulls Club",
  "collectionItem_url": "https://lh3.googleusercontent.com/3rllkFLC_4ZIjcKi9tKHfVMvhcaSw9SLaJ8GbOGg5Joouct5bpdeBNJLz3t9Tt1Q1YiDGsfA_mO8nlBlLsZxJ53ZG4yR_MpDU327Ji0=w206",
  "avatar": "https://lh3.googleusercontent.com/43adAijXmN5KxqP5jfuG7mFiVwe994MRuPhZCfbFd47YGWZG6fHYm9J6aRRPZnyEjm8kGATnGUOd253SaSdNpF883K6Xh_8YNlAWaJo=s64",
  "isVerified": true,
  "price": {
    "floor": 55.49
  },
  "change": {
    "day": {
      "percentage": 61.32,
      "amount": 2301.94
    },
    "week": {
      "percentage": -76.92,
      "amount": 11810.54
    },
    "month": {
      "percentage": -98.43,
      "amount": 41267.45
    }
  }
}, {
  "id": 13,
  "name": "Art Blocks Curated",
  "collectionItem_url": "https://lh3.googleusercontent.com/V7yIEHLmpvZUpKdzsdUkzWtRXOY67NcCiKEOekD5qtBtHRxUaSOpjnH0k23byzUW7OBhVvuYyrTV07wpFO6j70XRerHFJRI6WPa-=w206",
  "avatar": "https://lh3.googleusercontent.com/GwnosrkaneKGEkWySxvTSzZ5bEUjWkRuQzLSNfrpgy2-gxYjoR3m5PohLT9Fzy0p1tohajZ1g-LFfF_ZLnS1GqlPNHPUaKUbDhbf=s64",
  "isVerified": true,
  "price": {
    "floor": 11.15
  },
  "change": {
    "day": {
      "percentage": 38.33,
      "amount": 4243.84
    },
    "week": {
      "percentage": -20.62,
      "amount": 18560.63
    },
    "month": {
      "percentage": -61.41,
      "amount": 36320.51
    }
  }
}, {
  "id": 14,
  "name": "World of Women",
  "collectionItem_url": "https://lh3.googleusercontent.com/5-Nx0qj4MYyHG2-l9p_4U27ly5qddKsaV69Qs295VsXUvgKj0FYmtKq_TFv-ASFa-R9K-q8YnIs6ZSNE04EQvyDe5oIPwz8OUEDzhQ=w206",
  "avatar": "https://lh3.googleusercontent.com/EFAQpIktMBU5SU0TqSdPWZ4byHr3hFirL_mATsR8KWhM5z-GJljX8E73V933lkyKgv2SAFlfRRjGsWvWbQQmJAwu3F2FDXVa1C9F=s64",
  "isVerified": true,
  "price": {
    "floor": 55.39
  },
  "change": {
    "day": {
      "percentage": 99.9,
      "amount": 1597.68
    },
    "week": {
      "percentage": 82.64,
      "amount": 10198.35
    },
    "month": {
      "percentage": 46.5,
      "amount": 83000.72
    }
  }
}, {
  "id": 15,
  "name": "Gh0stly Gh0sts",
  "collectionItem_url": "https://lh3.googleusercontent.com/tlMxSh5Rf5FJW_mTTyw8jS_OwdD3BKf2F71Tk3noa1NSJlPTht8dBcm-RjoBiFEFQAkpbpcgXpbkHhdqOArOhxG_4t_mUiNG498WGw=w206",
  "avatar": "https://lh3.googleusercontent.com/MACJRvA4MOLHonq73rxU8TaHPrbYuGbJ5_rqV7pw9ZGd97h5mo5NyU6PpQNOvZzdoVu2KRVs3jP-oMK3FF1XQtNSxN6xf1ZVd9is=s64",
  "isVerified": true,
  "price": {
    "floor": 39.92
  },
  "change": {
    "day": {
      "percentage": 17.1,
      "amount": 4777.2
    },
    "week": {
      "percentage": 78.76,
      "amount": 11836.9
    },
    "month": {
      "percentage": 13.01,
      "amount": 91153.91
    }
  }
}, {
  "id": 16,
  "name": "fRiENDSiES",
  "collectionItem_url": "https://lh3.googleusercontent.com/tmDxtrM7y8dGsdMAZ-B598Y-GXkA_Eh0zOPhUMSKsKV71easUhB9_jlCUMMcgBgN0NlCNX6GqJR1HSnRW1_Qe3qrVgBmuMSQbsLUNw=w206",
  "avatar": "https://lh3.googleusercontent.com/kYHEXz4XAzgU5FzvUS-yu6H7sAIEhCUVOWXAzIXDenygg4c8pW4GZ4C4_LE-nitJ6VRhH_gG3_LEAoIr1Px8z_egduqKvudK5Y6V5Q=s64",
  "isVerified": true,
  "price": {
    "floor": 5.13
  },
  "change": {
    "day": {
      "percentage": 74.12,
      "amount": 8749.98
    },
    "week": {
      "percentage": -10.26,
      "amount": 13989.68
    },
    "month": {
      "percentage": -56.82,
      "amount": 91685.43
    }
  }
}, {
  "id": 17,
  "name": "Decentraland",
  "collectionItem_url": "https://lh3.googleusercontent.com/nYH0MhgV94bzuhPsC4S0ZO83DtA1551pnvD3ezWOpLExxz7Je7BbVP2k9hXYvC1ypMBkQbdMMUgQ-RbeEXayybeuqv7-MPyHY4La1RU=w206",
  "avatar": "https://lh3.googleusercontent.com/5KIxEGmnAiL5psnMCSLPlfSxDxfRSk4sTQRSyhPdgnu70nGb2YsuVxTmO2iKEkOZOfq476Bl1hAu6aJIKjs1myY=s64",
  "isVerified": false,
  "price": {
    "floor": 56.02
  },
  "change": {
    "day": {
      "percentage": -1.02,
      "amount": 1795.23
    },
    "week": {
      "percentage": 79.29,
      "amount": 10708.81
    },
    "month": {
      "percentage": 24.71,
      "amount": 84851.94
    }
  }
}, {
  "id": 18,
  "name": "illogics",
  "collectionItem_url": "https://lh3.googleusercontent.com/vxPRqRqF5XXXiKcY2WmySxPph8n8DIT4-9lUcGPOOf5FDxzODslqcSy5kr5gt8gEI6c20fDmWTMi9CH86GlPo5wuTMbiuFmCPV2q=w206",
  "avatar": "https://lh3.googleusercontent.com/wG9tN1YkG6xQ3AJ9zENy8v548QkLyK1HRZuCVc5GZSat2Ngh633aYNXZSMGVroN2b0j0AcfEj-ibKkIPsBu2fq0NStEbQWJB7BMm=s64",
  "isVerified": true,
  "price": {
    "floor": 64.5
  },
  "change": {
    "day": {
      "percentage": 41.8,
      "amount": 9877.29
    },
    "week": {
      "percentage": -42.6,
      "amount": 15636.61
    },
    "month": {
      "percentage": 55.82,
      "amount": 26310.88
    }
  }
}, {
  "id": 19,
  "name": "Forest Spirits  by  ZENFT",
  "collectionItem_url": "https://lh3.googleusercontent.com/esQDThqSsPd2PjTYZ7dkBdjzfuE3QgZAfh-IHq5bTHLYh2H4nbqTXBGQZPLC90B9EsolTgQNXrW81qvsn6jEhBxnI-wChE2tI69PCQ=w206",
  "avatar": "https://lh3.googleusercontent.com/ZKujAXVFIzvgS4j_3Z2uF7-keeDLrQwR-e8z9f15ro9bAL2P0oZJxZwAUO0Oj-TMJ2YnUJlcGyimbyDJgrH1OBj2_DOaimiTvyGdcg=s64",
  "isVerified": false,
  "price": {
    "floor": 87.46
  },
  "change": {
    "day": {
      "percentage": -19.71,
      "amount": 5349.71
    },
    "week": {
      "percentage": -18.91,
      "amount": 17615.65
    },
    "month": {
      "percentage": -37.02,
      "amount": 29272.56
    }
  }
}, {
  "id": 20,
  "name": "Cyber Factory 2",
  "collectionItem_url": "https://lh3.googleusercontent.com/kR7YztId1NIN9dmJO41Bb0ZlwvwBsBfl9-JhptqriL1laOqaZ6b_lCOi2WukIqxE0f7DMJ_sSvhYkaElNGvY2tA=w206",
  "avatar": "https://lh3.googleusercontent.com/72591rGu5Q4R7JeUjXyc1ZH2QJ2CW64OwKQ4Ec9Hf1_z8W6IgXNummT2ErPy80zh0DoUY8KXUXZdvgeUUw9HeIz8L11sYeNqTyD21y0=s64",
  "isVerified": true,
  "price": {
    "floor": 85.65
  },
  "change": {
    "day": {
      "percentage": -59.61,
      "amount": 2983.28
    },
    "week": {
      "percentage": 59.7,
      "amount": 12155.11
    },
    "month": {
      "percentage": 9.64,
      "amount": 86725.72
    }
  }
}, {
  "id": 21,
  "name": "Karafuru",
  "collectionItem_url": "https://lh3.googleusercontent.com/28jYQ9Toyfs8QPOUd_k86RhLSiventoMuhQjmqiE-TXVFlpoX_g_ncau0kO8GZb3-arCo712XcgsPZYyzYPop-V5=w206",
  "avatar": "https://lh3.googleusercontent.com/VMG3VFncJG-pyqsRAwQznZGqYDw4RkPjJnJNJwrDERFhD4pWLh82q66JJ8Qh0vCPoovjoyigJwLqfFpa5tMAVV5ASIiR5nF1XkQFpec=s64",
  "isVerified": true,
  "price": {
    "floor": 74.08
  },
  "change": {
    "day": {
      "percentage": 11.72,
      "amount": 4771.27
    },
    "week": {
      "percentage": 62.15,
      "amount": 17068.03
    },
    "month": {
      "percentage": -32.44,
      "amount": 85477.0
    }
  }
}, {
  "id": 22,
  "name": "GNSS by MGXS",
  "collectionItem_url": "https://lh3.googleusercontent.com/Uagikn-Lhn2W44V54_5UcsnMqrBESw6TkHV3PF_HiDXZZdryannrULVLEsrSeqLZxlSJZ3aA2E7hq3O62Ta4237jEQ=w206",
  "avatar": "https://lh3.googleusercontent.com/DZWZqpzB2oziNcsKBwjLVJScJuJYOajr_hgy6p5OxM_iy4is4Rec9GDCkrRrPNwGC3kh9NamwSFlK2gd4FM9oBqCZsBGdDiDa564XCU=s64",
  "isVerified": true,
  "price": {
    "floor": 80.77
  },
  "change": {
    "day": {
      "percentage": -72.27,
      "amount": 7425.5
    },
    "week": {
      "percentage": -95.3,
      "amount": 11978.3
    },
    "month": {
      "percentage": -46.86,
      "amount": 83919.6
    }
  }
}, {
  "id": 23,
  "name": "Ethlizards",
  "collectionItem_url": "https://lh3.googleusercontent.com/M9Tyqa3vOo5ApTCmIq0ot64XcjPb1NlImqhJnQmAmhWghbhF-oJrG-HVM7p4J9lQaHkIA_CAximNRn3H81dOP43S=w206",
  "avatar": "https://lh3.googleusercontent.com/xQtMH32KlwsBh0Ka2gwzHhy8Qu7-rbh15SQaPqz8xe7ZC1TH_MkSTgLAaNg4hPcsupacDqPVciBaXlqDNpZzDgGOfHHbXYaSxwGzUg=s64",
  "isVerified": false,
  "price": {
    "floor": 23.0
  },
  "change": {
    "day": {
      "percentage": 17.89,
      "amount": 8106.25
    },
    "week": {
      "percentage": -98.39,
      "amount": 19579.67
    },
    "month": {
      "percentage": 51.31,
      "amount": 60224.35
    }
  }
}]
